module.exports = require("js-sha3");